// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-ellipsis[data-v-1baebc0c]{text-overflow:ellipsis}.text-link.is-secondary[data-v-1baebc0c]:after{--tw-bg-opacity:1;background-color:#ccc;background-color:rgba(204,204,204,var(--tw-bg-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
